<template>
<div class="form-body">
  <div class="row">
    <div class="form-holder">
      <div class="form-content">
        <div class="form-items" style="margin-top: 5%;max-width: 620px;">
          <!-- <h3>Welcome to Screenit</h3> -->
          <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer placerat mi fringilla mauris ullamcorper</p> -->
          <div class="container" style="width: 100% !important;">
            <div class="col-md-12">
              <div class="box">
                <!-- <div class="box-header with-border">
                  <h4 class="box-title">Join Interview</h4>
                </div> -->
                <div class="box-body" style="padding: 30px !important;">
                  <img class="img" src="../../assets/img/payment_failed.png">
                  <h4 class="box-title"><b>Sorry! Your Payment is not Successful</b></h4>
                  <p class="box-title"><center>Your last transaction was cancelled, please try again for payment</center></p><br>
                  <p class="box-title"><center><a @click="resend()">Retry for Payment</a></center></p>
                  <!-- <button @click="dashboard()" class="btn btn-success" style="border-radius:6px !important;">rd</button> -->
                </div>
                <!-- <div class="box-footer clearfix">
                  <span>Interview session completed on <span class="color-g">{{start_datetime | formatDate}}</span> at <span class="color-g">{{start_datetime | time}} to {{end_datetime | time}}</span></span>
                  <a @click="viewresult()" v-if="type == 1" class="btn btn-sm btn-success btn-flat pull-right">view Result</a>
                </div> -->
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import router from '../../router/index'
export default {
  data () {
    return {
      title: 'name',
      type: localStorage.getItem('logtype')
    }
  },
  created () {
    console.log(this.type)
  },
  methods: {
    dashboard () {
      const routeData = this.$router.resolve({ name: 'Dashboard' })
      window.open(routeData.href, '_blank')
      // router.push({ name: 'Dashboard' })
    },
    resend () {
      router.push({ name: 'Selectpackage', params: { id: 'U2FsdGVkX1/r4ZSNI7tocdhWsR2tDFznfGgv9HmhmGw=' } })
    }
  }
}
</script>
<style scoped>
.passwardcompare {
  margin-top: 9px !important;
}
.img {
    width: 30% !important;
    margin-bottom: 15px;
}
.pwd_info {
  float: left;
  font-size: 12px;
  padding-bottom: 11px;
  color: red;
  margin-top: 0px;
}

.pwd_info_float_right {
  float: right;
  font-size: 12px;
  padding-bottom: 11px;
  color: #5BAD2B;
  /* cursor: pointer; */
  margin-top: -10px;
}

.pading_____zero {
  margin-bottom: 2px !important;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}

.form-holder {
  margin-left: 0px;
}

.login-policy-footer {
  width: 31%;
}

.progressbar {
  height: 5px !important;
  background: #e6e6e6;
}

ul {
  padding: 0px;
}

span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 0.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 7px;
}

.register____user__type {
  color: #000000;
  width: 44%;
  margin-left: 3%;
  margin-right: 3%;
  margin-bottom: 17px !important;
  cursor: pointer;
}

.progress_____round {
  border: 1px solid #5bad2b;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #5bad2b;
  font-weight: bold;
}

.progress_____round____hidden {
  border: 1px solid #bbb4b4;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #bbb4b4;
  font-weight: bold;
}
.form-content {
    width: auto;
}
.box {
  border-top: 0px solid #d2d6de;
  border-radius: 0px;
}
.form-content form {
    margin-bottom: 30px;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
}
.box-header .box-title {
    display: inline-block;
    font-size: 16px;
    margin: 0;
    line-height: 1;
    color:black;
}
.form-content .form-items {
    max-width: 540px;
}
html {
  height: 100% !important;
}
.form-content {
  background-color: #F5F5F5 !important;
}
.form-body {
  background-color: #F5F5F5 !important;
}
input {
  background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #DCDCDC;
}
.color-g {
  color: #5bad2b;
}
</style>
